const o = {
  tableContainer: {
    border: "1px solid #EFEFEF",
    borderRadius: {
      xs: "4px",
      sm: "8px"
    },
    display: "flex",
    flexDirection: "column",
    position: "relative",
    shadow: "none",
    overflowY: "auto",
    scrollbarWidth: "thin",
    padding: {
      xs: "0 8px",
      sm: "0 16px"
    },
    "&::-webkit-scrollbar": {
      width: {
        xs: "4px",
        sm: "8px"
      }
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent"
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#DADCE0",
      borderRadius: {
        xs: "2px",
        sm: "4px"
      }
    },
    backgroundColor: "#ffffff"
  },
  tableHead: {
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: "#ffffff",
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      borderBottom: "1px solid #EFEFEF"
    }
  },
  tableHeaderCell: {
    padding: {
      xs: "8px 0px 8px 8px",
      sm: "12px 0px 12px 16px"
    },
    position: "relative",
    color: "#878787",
    fontSize: {
      xs: "10px",
      sm: "12px"
    },
    fontWeight: "600",
    border: "none",
    "& .MuiButtonBase-root": {
      ":hover": {
        color: "#878787"
      }
    },
    "& .MuiButtonBase-root.Mui-active": {
      color: "#878787"
    }
  },
  tableHeaderRow: {
    backgroundColor: "#ffffff",
    ":hover": {
      backgroundColor: "#ffffff"
    }
  },
  filterIconContainer: {
    position: "absolute",
    right: {
      xs: "6px",
      sm: "10px"
    },
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "opacity 0.2s ease"
  },
  filterIcon: {
    height: {
      xs: "20px !important",
      sm: "24px !important"
    },
    width: {
      xs: "20px !important",
      sm: "24px !important"
    }
  },
  filterIconSvg: {
    fontSize: "16px !important"
  },
  tableBody: {
    position: "relative",
    backgroundColor: "#FFFFFF"
  },
  tableRow: {
    backgroundColor: "#FFFFFF"
  },
  tableCell: {
    padding: {
      xs: "8px 0",
      sm: "12px 0"
    },
    color: "#141414",
    fontSize: {
      xs: "10px",
      sm: "12px"
    },
    fontWeight: 500,
    borderBottom: "1px solid #EFEFEF",
    "&:first-of-type": {
      paddingLeft: {
        xs: "8px",
        sm: "16px"
      }
    },
    "&:last-of-type": {
      paddingRight: {
        xs: "8px",
        sm: "16px"
      }
    }
  },
  groupedRow: {
    display: "table-cell",
    paddingRight: {
      xs: "16px",
      sm: "32px"
    },
    borderBottom: "1px solid #EFEFEF",
    paddingTop: {
      xs: "8px",
      sm: "12px"
    },
    paddingBottom: {
      xs: "8px",
      sm: "12px"
    },
    fontSize: {
      xs: "10px",
      sm: "12px"
    },
    fontWeight: 500
  },
  groupedRowContent: {
    display: "flex",
    alignItems: "center",
    gap: {
      xs: "8px",
      sm: "12px"
    },
    "@media (max-width: 600px)": {
      flexWrap: "wrap"
    }
  },
  emptyStateCell: {
    padding: {
      xs: "24px 8px",
      sm: "48px 16px"
    },
    textAlign: "center",
    color: "#878787",
    fontSize: {
      xs: "12px",
      sm: "14px"
    },
    fontWeight: 500,
    borderBottom: "none",
    backgroundColor: "#ffffff"
  },
  loadingStateCell: {
    padding: {
      xs: "24px 8px",
      sm: "48px 16px"
    },
    textAlign: "center",
    borderBottom: "none"
  },
  defaultLoadingSpinner: {
    margin: "0 auto"
  },
  expandButton: {
    transition: "transform 150ms ease-in-out",
    padding: 0
  },
  columnFilterContainer: (t) => ({
    width: {
      xs: "200px",
      sm: "250px"
    },
    padding: {
      xs: "4px",
      sm: "8px"
    },
    [t.breakpoints.down("sm")]: {
      maxWidth: "90vw"
    }
  }),
  searchBarContainer: (t) => ({
    display: "flex",
    alignItems: "center",
    gap: {
      xs: "8px",
      sm: "16px"
    },
    [t.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "8px"
    }
  }),
  searchTextField: (t) => ({
    marginBottom: 0,
    "& .MuiInputBase-root": {
      paddingLeft: {
        xs: "6px",
        sm: "8px"
      },
      "& .MuiInputBase-input.MuiOutlinedInput-input": {
        padding: {
          xs: "4px 4px 4px 0px",
          sm: "6px 6px 6px 0px"
        },
        fontSize: {
          xs: "10px",
          sm: "12px"
        }
      }
    },
    [t.breakpoints.down("sm")]: {
      width: "100%"
    }
  }),
  tableSearchTextField: (t) => ({
    ml: {
      xs: 0,
      sm: "auto"
    },
    minWidth: {
      xs: "100%",
      sm: "346px"
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: {
        xs: "4px",
        sm: "6px"
      },
      height: {
        xs: "28px",
        sm: "32px"
      },
      fontSize: {
        xs: "10px",
        sm: "12px"
      }
    },
    "& .MuiInputAdornment-root": {
      marginRight: {
        xs: "6px",
        sm: "8px"
      },
      marTextFit: 1
    },
    [t.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: 0
    }
  }),
  filterOptionRow: (t) => ({
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f5f5f5"
    },
    paddingLeft: {
      xs: "4px",
      sm: "8px"
    },
    paddingRight: {
      xs: "4px",
      sm: "8px"
    },
    [t.breakpoints.down("sm")]: {
      padding: "8px 4px"
    }
  }),
  filterCheckbox: {
    padding: {
      xs: "2px",
      sm: "4px"
    },
    "& .MuiSvgIcon-root": {
      fontSize: {
        xs: "14px",
        sm: "16px"
      }
    },
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  filterOptionText: {
    fontSize: {
      xs: "10px",
      sm: "12px"
    }
  },
  noResultsText: {
    padding: 1,
    textAlign: "center"
  },
  columnResizer: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    height: "100%",
    userSelect: "none",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  resizerHandle: {
    width: "2px",
    height: "10px",
    backgroundColor: "#8080802e",
    borderRadius: "5px",
    cursor: "col-resize"
  },
  paginationContainer: (t) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderTop: "1px solid #EFEFEF",
    backgroundColor: "#ffffff",
    position: "sticky",
    bottom: 0,
    left: {
      xs: -8,
      sm: -16
    },
    right: {
      xs: -8,
      sm: -16
    },
    minHeight: "min-content",
    zIndex: 2,
    padding: {
      xs: "0px 8px",
      sm: "0px 16px"
    },
    marginRight: {
      xs: "-8px",
      sm: "-16px"
    },
    marginLeft: {
      xs: "-8px",
      sm: "-16px"
    },
    marginTop: "auto",
    [t.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "8px",
      padding: "8px"
    }
  }),
  tablePagination: (t) => ({
    backgroundColor: "#ffffff",
    minHeight: "min-content",
    "& .MuiTablePagination-toolbar": {
      minHeight: {
        xs: "40px",
        sm: "48px"
      },
      "& .MuiTablePagination-selectLabel": {
        margin: "0px",
        marginBottom: {
          xs: "2px",
          sm: "4px"
        },
        fontSize: {
          xs: "10px",
          sm: "12px"
        }
      },
      "& .MuiTablePagination-select": {
        fontSize: {
          xs: "10px",
          sm: "12px"
        },
        "& .MuiSelect-select": {
          padding: {
            xs: "0px 16px 0px 6px",
            sm: "0px 24px 0px 8px"
          }
        }
      }
    },
    marginLeft: {
      xs: 0,
      sm: "auto"
    },
    [t.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "center"
    }
  }),
  paginationText: {
    marginTop: "0px",
    color: "#141414",
    fontWeight: 500,
    fontSize: {
      xs: "10px",
      sm: "12px"
    }
  },
  paginationRowsPerPageText: {
    color: "#878787",
    fontWeight: 500,
    fontSize: {
      xs: "10px",
      sm: "12px"
    }
  },
  paginationActions: (t) => ({
    display: "flex",
    gap: {
      xs: 0.25,
      sm: 0.5
    },
    alignItems: "center",
    marginLeft: {
      xs: "6px",
      sm: "12px"
    },
    [t.breakpoints.down("sm")]: {
      justifyContent: "center",
      marginLeft: 0
    }
  }),
  paginationButton: {
    "&:hover": {
      backgroundColor: "action.hover"
    }
  },
  rowsPerPageStack: (t) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    spacing: {
      xs: 1,
      sm: 2
    },
    padding: {
      xs: "6px 0px",
      sm: "10px 0px"
    },
    marginLeft: {
      xs: 0,
      sm: "auto"
    },
    [t.breakpoints.down("sm")]: {
      justifyContent: "center",
      marginLeft: 0
    }
  }),
  rowsPerPageText: {
    fontSize: {
      xs: "10px",
      sm: "12px"
    },
    fontWeight: 500,
    color: "#878787"
  },
  rowsPerPageSelect: {
    marginLeft: {
      xs: "6px",
      sm: "9px"
    },
    borderRadius: {
      xs: "6px",
      sm: "8px"
    },
    height: {
      xs: "24px",
      sm: "28px"
    },
    fontSize: {
      xs: "10px",
      sm: "12px"
    },
    color: "#878787",
    backgroundColor: "#F7F7F7",
    "& fieldset": {
      borderColor: "#EFEFEF !important",
      borderWidth: "1px !important"
    }
  },
  paginationStyle: (t) => ({
    color: "#226A58",
    "&.MuiPagination-root.MuiPagination-outlined": {
      marginLeft: {
        xs: "8px",
        sm: "16px"
      },
      "& ul": {
        gap: {
          xs: "2px",
          sm: "4px"
        },
        "& li": {
          "& button": {
            margin: 0,
            backgroundColor: "#FFFFFF",
            color: "#141414",
            borderRadius: {
              xs: "6px",
              sm: "8px"
            },
            border: "1px solid #CDD2DBB2",
            fontSize: {
              xs: "11px",
              sm: "13px"
            },
            fontWeight: 500,
            minWidth: {
              xs: "28px",
              sm: "32px"
            },
            height: {
              xs: "28px",
              sm: "32px"
            },
            "&:hover": {
              backgroundColor: "#F7F7F7"
            },
            "&.Mui-selected": {
              backgroundColor: "#226A58",
              color: "#FFFFFF",
              borderRadius: {
                xs: "6px",
                sm: "8px"
              },
              border: "none"
            }
          }
        }
      }
    },
    [t.breakpoints.down("sm")]: {
      "&.MuiPagination-root.MuiPagination-outlined": {
        marginLeft: 0,
        "& ul": {
          justifyContent: "center"
        }
      }
    }
  }),
  virtualizedTableBody: {
    height: "100%",
    overflow: "hidden",
    tableLayout: "fixed",
    width: "100%"
  },
  virtualizedTableCell: {
    padding: 0,
    width: "100%"
  },
  virtualizedListContainer: {
    position: "relative",
    width: "100%",
    height: "100%"
  },
  virtualizedList: {
    overflowX: "hidden",
    width: "100%"
  },
  checkbox: {
    padding: "0px",
    width: {
      xs: "14px",
      sm: "16px"
    },
    height: {
      xs: "18px",
      sm: "20px"
    },
    "&.Mui-checked": {
      color: "#226A58"
    },
    "&.MuiCheckbox-indeterminate": {
      color: "#226A58"
    }
  },
  dragGhost: {
    position: "fixed",
    top: "-1000px",
    left: "-1000px",
    padding: "0",
    pointerEvents: "none"
  },
  dragGhostCard: {
    background: "#ffffff",
    borderRadius: "4px",
    boxShadow: "0px 4px 7px 0px #0000001A",
    padding: "8px",
    position: "absolute",
    height: "100%"
  },
  dragGhostText: {
    color: "#222325",
    fontSize: "12px",
    fontWeight: "400",
    whiteSpace: "nowrap",
    visibility: "hidden",
    position: "absolute",
    padding: "8px"
  },
  dragGhostStackContainer: {
    position: "relative",
    height: "31px"
  },
  dragGhostTopCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "max-content"
  },
  dragGhostRow: {
    color: "#222325",
    fontSize: "12px",
    fontWeight: "400",
    whiteSpace: "wrap",
    textAlign: "center"
  },
  dragGhostIconContainer: {
    position: "absolute",
    top: "1px",
    left: "-7px",
    transform: "translateY(-50%)",
    zIndex: "15",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: "1"
  },
  headerSelectionCell: {
    width: {
      xs: "32px",
      sm: "38px"
    },
    maxWidth: {
      xs: "32px",
      sm: "38px"
    },
    minWidth: {
      xs: "32px",
      sm: "38px"
    }
  },
  headerDragCell: {
    paddingLeft: {
      xs: "8px",
      sm: "16px"
    },
    width: {
      xs: "32px",
      sm: "40px"
    },
    maxWidth: {
      xs: "32px",
      sm: "40px"
    },
    minWidth: {
      xs: "32px",
      sm: "40px"
    }
  },
  bodySelectionCell: {
    paddingLeft: {
      xs: "16px",
      sm: "32px"
    },
    borderBottom: "1px solid #EFEFEF",
    width: {
      xs: "28px",
      sm: "32px"
    },
    maxWidth: {
      xs: "28px",
      sm: "32px"
    },
    minWidth: {
      xs: "28px",
      sm: "32px"
    }
  },
  bodyDragCell: {
    paddingLeft: {
      xs: "8px",
      sm: "16px"
    },
    width: {
      xs: "32px",
      sm: "40px"
    },
    maxWidth: {
      xs: "32px",
      sm: "40px"
    },
    minWidth: {
      xs: "32px",
      sm: "40px"
    }
  },
  bodyDragCellNoSelection: {
    paddingLeft: {
      xs: "16px",
      sm: "32px"
    }
  },
  dragIndicator: {
    color: "grey",
    cursor: "grab",
    height: {
      xs: "14px",
      sm: "16px"
    },
    width: {
      xs: "14px",
      sm: "16px"
    }
  },
  dragIndicatorContainer: {
    display: "flex",
    alignItems: "center",
    height: "100%"
  },
  bodyCell: {
    paddingLeft: {
      xs: "8px",
      sm: "16px"
    },
    paddingRight: {
      xs: "8px",
      sm: "16px"
    },
    borderBottom: "1px solid #EFEFEF",
    boxSizing: "border-box",
    // Custom cell renderers commonly wrap their content in a nested Box/Typography,
    // which creates its own block box that the TableCell's own text-overflow can't
    // reach into (ellipsis only clips an element's own direct inline content).
    // Cascade the same clipping onto the cell's direct child so nested renderers
    // still get an ellipsis instead of a hard, dot-less clip.
    "& > *": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "100%",
      minWidth: 0
    }
  },
  bodyCellFirst: {
    paddingLeft: {
      xs: "16px",
      sm: "32px"
    }
  },
  bodyCellLast: {
    paddingRight: {
      xs: "16px",
      sm: "32px"
    }
  },
  bodyCellLastRow: {
    borderBottom: "none"
  }
};
export {
  o as styles
};
